export default "__VITE_ASSET__29c35291__"